import styled from "styled-components";

import { theme } from "../../styles/theme";

export const Title = styled.div`
  color: ${theme.colors.lightBlue};
  font-family: "Poppins";
  margin-bottom: 15px;
`;

export const LabelStyled = styled.div`
  color: ${theme.colors.white};
  font-size: 12px;
  margin-right: 15px;
`;
export const RowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 9px;
  width: 100%;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const ValueStyled = styled.div`
  border-radius: 20px;
  border: 1px solid ${theme.colors.lightGray};
  padding: 3px 10px;
  color: ${theme.colors.white};
  font-size: 14px;
  min-width: 70%;
`;

export const SectionStyled = styled.div``;

export const Wrapper = styled.div`
  padding: 15px;
  font-family: ${theme.font.poppins};

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;
